import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-button-toggle-container',
  templateUrl: './skeleton-button-toggle-container.component.html',
  styleUrls: ['./skeleton-button-toggle-container.component.scss'],
})
export class SkeletonButtonToggleContainerComponent {}
